import GridLoadMore from "./grid-load-more";

export default GridLoadMore;